<template>
  <label class="form-check-label checkbox-field-container" :class="{ 'opacity-50': disabled }">

    <div class="d-flex align-items-center justify-content-between w-100">

      <span class="checkbox-label-text">
        <i v-if="icon" :class="[icon, 'me-1']"></i>
        {{ label }}
      </span>

      <input type="checkbox" class="form-check-input" :checked="modelValue" :disabled="disabled"
        @change="$emit('update:modelValue', $event.target.checked)">
    </div>

  </label>
</template>

<script>
export default {
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.checkbox-field-container {
  display: block;
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 0.9rem;
  margin-bottom: 0;
}

.checkbox-field-container:hover {
  background-color: #f8f9fa;
}

.checkbox-field-container.opacity-50 {
  cursor: not-allowed;
  background-color: #f1f1f1;
}

.checkbox-label-text {
  line-height: 1.5;
  user-select: none;
}

.form-check-input {
  margin-top: 0;
  flex-shrink: 0;
}

.form-check-input:checked {
    background-color: #198754 !important; 
    border-color: #198754   !important;
    
    opacity: 1; 

    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e");
}

.form-check-input:focus {
    border-color: #198754;
    box-shadow: 0 0 0 0.25rem rgba(25, 135, 84, 0.25);
}

</style>